import { gql } from "@apollo/client";

const GET_CLIENTS_WITH_INVOICES = gql`
  query clientsWithInvoices(
    $invoiceStatuses: [InvoiceProcessStatus]
    $clientIdentifier: String
    $sortBy: ClientAggregationSortBy
    $sortDirection: SortDirection
    $tags: [String]
    $invoiceDateFrom: Date
    $invoiceDateTo: Date
    $dueDateFrom: Date
    $dueDateTo: Date
    $amountFrom: Decimal
    $amountTo: Decimal
    $registrationStatuses: [InvoiceRegistrationStatus]
    $validationStatuses: [InvoiceValidationStatus]
    $assessmentStatuses: [InvoiceAssessmentStatus]
    $skip: Int
    $take: Int
  ) {
    clientsWithInvoices(
      invoiceStatuses: $invoiceStatuses
      clientIdentifier: $clientIdentifier
      sortBy: $sortBy
      sortDirection: $sortDirection
      tags: $tags
      invoiceDateFrom: $invoiceDateFrom
      invoiceDateTo: $invoiceDateTo
      dueDateFrom: $dueDateFrom
      dueDateTo: $dueDateTo
      amountFrom: $amountFrom
      amountTo: $amountTo
      registrationStatuses: $registrationStatuses
      validationStatuses: $validationStatuses
      assessmentStatuses: $assessmentStatuses
      skip: $skip
      take: $take
    ) {
      totalCount
      items {
        client {
          id
          identifier
          name
        }
        filteredTotalAmountByCurrency {
          amount
          currency
        }
        filteredTotalCount
        statusCounts {
          status
          count
        }
        unhandledDocumentCount
      }
    }
  }
`;

export default GET_CLIENTS_WITH_INVOICES;
